import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'
import { type Field, NumberUtils, PuiCheckbox } from '@pbt/pbt-ui-components'

import FeatureToggle from '~/constants/featureToggle'
import { getCurrentBusinessTaxes } from '~/store/reducers/auth'
import { getFeatureToggle } from '~/store/reducers/constants'

export interface VariationPricingPreTaxFeesProps {
  readonly field: Field
}

const asTaxIdList = (value: Field['value']): string[] =>
  Array.isArray(value) ? (value as string[]) : []

const VariationPricingPreTaxFees = ({
  field,
}: VariationPricingPreTaxFeesProps) => {
  const isPreTaxFeeCollectionEnabled = useSelector(
    getFeatureToggle(FeatureToggle.PRE_TAX_FEE_COLLECTION),
  )
  const allBusinessTaxes = useSelector(getCurrentBusinessTaxes)
  const preTaxFees = allBusinessTaxes.filter((tax) => tax.preTaxFee === true)

  if (!isPreTaxFeeCollectionEnabled || preTaxFees.length === 0) {
    return null
  }

  return (
    <Grid container item alignItems="flex-end" columnSpacing={1} wrap="nowrap">
      {preTaxFees.map((fee) => (
        <Grid item key={fee.id}>
          <PuiCheckbox
            field={{
              value: asTaxIdList(field.value).includes(fee.id),
              set: () => {
                const ids = asTaxIdList(field.value)
                const without = ids.filter((taxId) => taxId !== fee.id)
                field.setValue(
                  ids.includes(fee.id) ? without : [...without, fee.id],
                )
              },
            }}
            label={`${fee.name} | ${NumberUtils.toPercentFormat(fee.rateValue, 2)}`}
          />
        </Grid>
      ))}
    </Grid>
  )
}

export default VariationPricingPreTaxFees
